import { EventEmitter, Injectable } from "@angular/core";
import { GtmService } from "@core/services/analytics/gtm.service";
import { environment } from "@environment";

declare global {
    interface Window {
        ymConfig: any;
        YellowMessenger: any;
    }
}

@Injectable({
    providedIn: "root"
})
export class ChatbotService {
    yellowMessengerScriptLoaded: boolean;
    isChatBotClosed: EventEmitter<boolean> = new EventEmitter();

    constructor(private gtmService: GtmService) { }

    chatConfig() {
        return new Promise((resolve, reject) => {
            if (this.yellowMessengerScriptLoaded) {
                return resolve(true);
            }
            
            window["ymConfig"] = {
                "bot": environment.ymBotId
            };
            var w = window;
            if ("function" === typeof w["YellowMessenger"])
                w["YellowMessenger"]("reattach_activator"),
                    w["YellowMessenger"]("update", "ymConfig");
            else {
                var i = function () {
                    i["c"](arguments);
                };
                var e = document.createElement("script");
                (e.type = "text/javascript"),
                    (e.async = !0),
                    (e.src =
                        "https://cdn.yellowmessenger.com/plugin/widget-v2/latest/dist/main.min.js");
    
                e.onerror = (e) => {
                    console.log(e);
                    this.gtmService.logWebAnalyticsEvent("script_failure", "Failed To Load yellowmessenger");
                    return reject(false);
                };

                e.onload = () => {
                    this.yellowMessengerScriptLoaded = true;
                }
    
                var t = document.getElementsByTagName("script")[0];
                t.parentNode.insertBefore(e, t);
                return resolve(t);
            }
        });
    }

    addMessageListener() {
        window.addEventListener("message", this.handleMessageListener, false);
    }

    removeMessageListener() {
        window.removeEventListener("message", this.handleMessageListener, false);
    }

    handleMessageListener = (eventData: any) => {
        try {
            let event = JSON.parse(eventData.data);
            if (event?.event_code === "ym-bot-closed") {
                this.removeMessageListener();
                this.isChatBotClosed.emit(true);
            }
        } catch (e) {}
    }
}
